import { render } from "./Recommendations.vue?vue&type=template&id=0ec7441f&scoped=true"
import script from "./Recommendations.vue?vue&type=script&lang=js"
export * from "./Recommendations.vue?vue&type=script&lang=js"

import "./Recommendations.vue?vue&type=style&index=0&id=0ec7441f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec7441f"]])

export default __exports__